// extracted by mini-css-extract-plugin
export default {"backdrop_background_color":"rgba(173,181,189,.5)"};